import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';
import cx from '@/utils/cx';

const SegmentContext = createContext(null);

const Segment = ({
  validation,
  formatter,
  children,
  type,
  value,
  onChange,
  color,
  className,
  ...rest
}) => {
  const classes = useStyle({ type });
  const hashedValue = useMemo(() => JSON.stringify(value), [value]);
  const { Provider } = SegmentContext;

  return (
    <Provider value={{
      onChange,
      hashedValue,
      color,
      type,
    }}>
      <div
        className={cx(classes.segment, className)}
        {...rest}
      >
        {children}
      </div>
    </Provider>
  );
};

Segment.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  // eslint-disable-next-line react/require-default-props
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
  type: PropTypes.oneOf([1, 2]),
};

Segment.defaultProps = {
  value: undefined,
  color: 'primary',
  type: 1,
};

export { Segment, SegmentContext };
export default Segment;
